import { render, staticRenderFns } from "./LatestResourcesSlider.vue?vue&type=template&id=a5de977e&"
import script from "./LatestResourcesSlider.vue?vue&type=script&lang=js&"
export * from "./LatestResourcesSlider.vue?vue&type=script&lang=js&"
import style0 from "./LatestResourcesSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports